export enum ProdutoCategoria {
  CATALOGO = 1,
  LOJA = 0,
}

export type NovoProduto = Omit<Produto, "id">;

export interface Produto {
  id: number;
  nome: string;
  categoria: ProdutoCategoria;
  autores: string;
  preco: number;
  desconto: number;
  descricao: string;
  informacaoAdicional: string;
  fotoCapaUrl: string;
  fotoProdutosUrls: string[];
  peso: number;
  altura: number;
  comprimento: number;
  largura: number;
  quantidadeEstoque: number;
  ativo: boolean;
}

export interface CarrinhoItem extends Produto {
  quantidade: number;
}

export interface ClienteData {
  name: string;
  email: string;
  cpf_cnpj: string;
  endereco: string;
  cidade: string;
  estado: string;
  cep: string;
  numero: string;
  complemento: string;
}

export interface FormErrors {
  [key: string]: string;
}

export interface OrderDetails {
  id: number;
  statusHistory: {
    status: string;
    date: string | null;
    concluida: boolean;
  }[];
}

export interface CobrancaPixResult {
  codigo_solicitacao: string;
  pix_copia_e_cola: string;
  valor: number;
}

export interface Store {
  products: Produto[];
  cartItems: CarrinhoItem[];
  isCartOpen: boolean;
  isCheckoutOpen: boolean;
  clienteData: ClienteData;
  formErrors: FormErrors;
  isSubmitting: boolean;
  navigate: ((path: string) => void) | null;
  cartTotal: number;

  setNavigate: (navigate: (path: string) => void) => void;
  toggleCart: () => void;
  addToCart: (product: Produto) => void;
  removeFromCart: (productId: number) => void;
  updateQuantity: (productId: number, quantity: number) => void;
  startCheckout: (cep: string, frete: number, envio: string) => void;
  cancelCheckout: () => void;
  updateCustomerData: (field: keyof ClienteData, value: string) => void;
  validateForm: () => boolean;
  confirmOrder: (
    forma_envio_id: number,
    forma_pagamento_id: number,
    preco_frete: number
  ) => Promise<number>;
  gerarCobrancaPix: (pedidoId: number) => Promise<CobrancaPixResult | null>;
  loadProducts: () => void;
  checkOrder: (orderId: number, email: string) => Promise<OrderDetails>;
}
